import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 登录
 */
export const fetchLogin = async (options) => {
    const res = await POST(APIs.API_USER_LOGIN, options);

    return res.data.data ?? {};
};

/**
 * 发送登录验证码
 */
export const fetchSendVerify = async () => {
    return await POST(APIs.API_USER_SEND_VERIFY);
};

/**
 * 验证
 */
export const fetchVerify = async (code) => {
    const res = await POST(APIs.API_USER_VERIFY, { data: { verify_code: code } });

    return res.data.data ?? {};
};

/**
 * 获取账户详情
 */
export const fetchUserProfile = async () => {
    const res = await GET(APIs.API_USER_PROFILE);

    return res.data.data ?? {};
};

/**
 * 登出
 */
export const fetchLogout = async () => {
    return await GET(APIs.API_USER_LOGOUT);
};